import store from 'config/store'
import { clearActiveCampaign } from 'modules/campaigns/actions'
import { listen } from 'utils/message'

const UseRemoveActiveCampaign = () => {
  listen({
    topic: 'CONDUCTOR:remove-active-campaign',
    handler: event => {
      store.dispatch(
        clearActiveCampaign()
      )
    }
  })
}

export default UseRemoveActiveCampaign
